import { ListData } from '@fi-app/components/items-list/list-data.service';
import { CurrencyTypes } from '../customer-billing-price/currency-type';
import { ObjectTypes } from '@fi-shared/types/object-type';
import {
    ItemsListElementType,
    ItemsListHeader,
    ItemsListHeaderProperties,
} from '@fi-app/components/items-list/items-list-header';
import { fiPaymentMethodTypeName } from '../payment-method-type';
import { MonthlyInvoicesListItemComponent } from '../customer-billing-customer/monthly-invoices-list-item/monthly-invoices-list-item.component';
import { OtherInvoicesListItemComponent } from '../customer-billing-customer/other-invoices-list-item/other-invoices-list-item.component';
import { CustomerBillingCustomerModel } from '../customer-billing-customer/customer-billing-customer.model';
import { Injector } from '@angular/core';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { createMap } from '@fi-shared/utils/create-map';

export class CustomerBillingCustomerUnitListData extends ListData<CustomerBillingCustomerModel> {
    private CurrencyTypesMap = createMap(CurrencyTypes, 'Id');

    constructor(injector: Injector) {
        super(injector);
        this.ShowDelete = false;
        this.ObjectType = ObjectTypes.CustomerBillingCustomer;

        this.IdColumn = 'CustomerBusinessUnitId';
        this.ChildProperty = 'ChildItems';

        this.Header.push(
            new ItemsListHeader(
                this.appTextService.get('common.customer'),
                'Name',
                new ItemsListHeaderProperties('CcmListItem-Name', true, ItemsListElementType.A, {
                    Sref: (row) => {
                        if (row.ParentId) return FiStateNames.CustomerBilling.CustomerUnits.View;

                        return '.';
                    },
                    SrefParams: (data) => {
                        if (data.ParentId) return { UnitId: data.BusinessUnitId, CustomerId: data.CustomerId };

                        return undefined;
                    },
                }),
            ),
        );

        this.addSpanPlainHeader(
            this.appTextService.get('billing.payment_method'),
            'PaymentMethodType',
            '',
            true,
            (data, property) => {
                return fiPaymentMethodTypeName(data[property], this.appTextService);
            },
        );

        this.Header.push(
            new ItemsListHeader(
                this.appTextService.get('customer_billing.monthly_invoices'),
                'CurrentMonthlyInvoice',
                new ItemsListHeaderProperties('', false, MonthlyInvoicesListItemComponent),
            ),
        );

        this.Header.push(
            new ItemsListHeader(
                this.appTextService.get('customer_billing.other_invoices'),
                'OtherInvoices',
                new ItemsListHeaderProperties('', false, OtherInvoicesListItemComponent),
            ),
        );

        this.addSpanPlainHeader(
            this.appTextService.get('common.discount') + ' %',
            'Discount',
            '',
            true,
            this.formatPercents,
        );

        this.addSpanPlainHeader(
            this.appTextService.get('billing.extra_discount') + ' %',
            'ExtraDiscount',
            '',
            true,
            this.formatPercents,
        );

        this.addSpanPlainHeader(this.appTextService.get('billing.currency'), 'Currency', '', true, (data, property) => {
            if (data.InvoiceInfo && this.CurrencyTypesMap.hasOwnProperty(data.InvoiceInfo[property]))
                return this.appTextService.get(this.CurrencyTypesMap[data.InvoiceInfo[property]].TextId);

            if (data.CreditCardInfo && this.CurrencyTypesMap.hasOwnProperty(data.CreditCardInfo[property]))
                return this.appTextService.get(this.CurrencyTypesMap[data.CreditCardInfo[property]].TextId);

            return '-';
        });
    }

    private formatPercents(data, property) {
        return data[property] > 0 ? data[property] + '%' : '-';
    }
}
